import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { MuiThemeProvider } from "@material-ui/core/styles";
import registerServiceWorker from "./registerServiceWorker";
import theme from "./styling/theme";

function Root() {
  return (
    // <MuiThemeProvider theme={theme}>
    <App />
    // </MuiThemeProvider>
  );
}

ReactDOM.render(<Root />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js